import { t } from '@lingui/macro';
import { DialogHeader, DialogFooter, Alert } from '@pocketlaw/tetris';
import { FormDialog, SubmitButton } from 'shared/domains/forms';
import { schema } from '../../utils/validationSchema';
import { AssigneePermission } from '../AssigneePermission';
import { AssigneesField } from '../AssigneesField';
import { AttachmentAdd } from '../AttachmentAdd';
import { AttachmentField } from '../AttachmentField';
import { CloseTaskDialogButton } from '../CloseTaskDialogButton';
import { DueDateField } from '../DueDateField';
import { PublicField } from '../PublicField';
import { ReminderField } from '../ReminderField';
import { TextAreaField } from '../TextAreaField';
import { TextInputField } from '../TextInputField';
import { StyledDialogContent, InputFieldContainer, LinkFieldContainer, AttachmentsFieldContainer, } from './styled';
export function TaskDialog(props) {
    const { title, onSubmit, onClose, error, initialValues, buttonTitle } = props;
    return (<FormDialog onClose={onClose} size="sm" initialValues={initialValues} onSubmit={onSubmit} validationSchema={schema}>
      <DialogHeader title={title} action={<CloseTaskDialogButton onClick={onClose}/>}/>

      <StyledDialogContent>
        {error && (<Alert appearance="danger" pale message={t({ message: 'An error occurred.', comment: 'Add task error alert message' })}/>)}
        <InputFieldContainer>
          <TextInputField name="title" label={t({ message: 'Title', comment: 'task title field label' })}/>
          <TextAreaField name="description" label={t({ message: 'Description', comment: 'task description field label' })}/>
        </InputFieldContainer>
        <LinkFieldContainer>
          <PublicField />
          <DueDateField />
          <ReminderField />
          <AssigneesField />
        </LinkFieldContainer>
        <AttachmentsFieldContainer>
          <AttachmentField />
          <AttachmentAdd />
          <AssigneePermission />
        </AttachmentsFieldContainer>
      </StyledDialogContent>
      <DialogFooter>
        <SubmitButton>{buttonTitle}</SubmitButton>
      </DialogFooter>
    </FormDialog>);
}
